import { useEffect, useState, useRef } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import * as actionUrl from "../../store/actions";
import SockJS from "sockjs-client";
import Stomp from "stompjs";

const CatalogTable = ({
    userWiseViewEnglishAuctionData,
    setuserWiseViewEnglishAuctionData,
    setshowListMsg,
    auctionItemRowId,
    selectedRowsRemove,
    handleSelectRowRemove,
    handleChangeCatalog,
    handleButtonCatalog,
    handleButtonChangePrice,
    myCatalogViewdata, 
    setMyCatalogViewData,
    setAuctionItemDetails,
    auctionItemDetails
}) => {

    const dispatch = useDispatch()
    const [previousValue, setPreviousValue] = useState(null)
    const [disableField, setDisableField] = useState(false)

    const [editableRowId, setEditableRowId] = useState(null);
    const [editableColumnIndex, setEditableColumnIndex] = useState(null);
    const [rpvalue, setRpValue] = useState(null);
    const [isKeyboardEvent, setIsKeyboardEvent] = useState(false);
    const [currentValue, setCurrentValue] = useState('');

    const lastAlertMessage = useRef(null);

    const [prevReservePriceRef, setPrevReservePriceRef] = useState(null)

    const loading = useSelector((state) => state?.EnglishVR?.loadingCatalog);
    const userRoleCode = atob(localStorage.getItem("argument6"));
    const auctionDetailId =
    window.location.pathname &&
    window.location.pathname.split("/") &&
    window.location.pathname.split("/")[2]
    ? atob(
        window.location.pathname &&
          window.location.pathname.split("/") &&
          window.location.pathname.split("/")[2]
      )
    : "";

    const userId =
    window.location.pathname &&
    window.location.pathname.split("/") &&
    window.location.pathname.split("/")[3]
      ? atob(
          window.location.pathname &&
            window.location.pathname.split("/") &&
            window.location.pathname.split("/")[3]
        )
      : ""; 
    const alertMessage = useSelector(
        (state) => state?.EnglishVR?.changePrice?.responseData
    );

    const handleDragStart = (e, index) => {
        e.dataTransfer.setData("index", index);
    };
    
    const handleDragOver = (e) => {
        e.preventDefault();
    };

    const handleBlur = (auctionItemDetailId) => {

      setMyCatalogViewData((prevData) => {
        const updatedData = prevData?.liveBidDetails.map((item) => {
          if (item.auctionItemDetailId === auctionItemDetailId) {
            const updatedColumnDetails = item?.columnDetails.map((columnDetail) => {
              if (columnDetail.columnTypeId === 13) {
                // Update column value (RP) with the new value from alertMessage
                columnDetail.columnValue = previousValue;
              }
              return columnDetail;
            });

            item.columnDetails = updatedColumnDetails;
          }
          return item;
        });
        return {...prevData, liveBidDetails: updatedData};
      });

    }

    const handleDoubleClick = (auctionItemDetailId, rpvalue) => {

        if (isKeyboardEvent) {
          setIsKeyboardEvent(false); // Reset the flag
          return;
        }
  
        if (editableRowId == auctionItemDetailId ) {
          return;
        }

        setPreviousValue(rpvalue);
        if(userRoleCode == "AUCTIONEER" || 
        userRoleCode == "ASSOCIATEAUCTIONEER" ||
        userRoleCode == "POSTAUCTIONASSOCIATEAUCTIONEER" ) {
          setEditableRowId(auctionItemDetailId); 
          setRpValue(rpvalue)
        }
      };

    const isRpButtonClicked = useSelector((state)=> state?.EnglishVR?.isRpButtonClicked)

    const handleDrop = (e, dropIndex) => {
        e.preventDefault();
        const dragIndex = parseInt(e.dataTransfer.getData("index"));
    
        if (!isNaN(dragIndex)) {
          // Create a copy of the columns to perform the drag & drop
          const newColumns = [...myCatalogViewdata?.columnDetails];
    
          // Get the dragged column
          const draggedColumn = newColumns[dragIndex];
    
          // Remove dragged column and place it at the dropIndex
          newColumns.splice(dragIndex, 1);
          newColumns.splice(dropIndex, 0, draggedColumn);
    
          // Update sortOrder
          const updatedColumns = [...newColumns];
    
          // Adjust the sortOrder for the affected columns
          const dragSortOrder = updatedColumns[dragIndex].sortOrder;
    
          if (dragIndex < dropIndex) {
            updatedColumns.forEach((column, index) => {
              if (index === dropIndex) {
                column.sortOrder = index + 1;
              } else if (index === dragIndex) {
                column.sortOrder = index + 1;
              } else if (index > dragIndex && index <= dropIndex) {
                column.sortOrder = index + 1;
              }
            });
          } else {
            // If dragging the item after the target (dragIndex > dropIndex), we shift sort orders up
            updatedColumns.forEach((column, index) => {
              if (index === dropIndex) {
                column.sortOrder = index + 1;
              } else if (index === dragIndex) {
                column.sortOrder = index + 1;
              } else if (index < dragIndex && index >= dropIndex) {
                column.sortOrder = index + 1;
              }
            });
          }
    
          // Now, update the auctionDataLiveBidDetails to reflect the column order change
          // myCatalogViewdata &&
          // myCatalogViewdata?.columnDetails.map((row) => {
          let dragData = myCatalogViewdata?.columnDetails[dragIndex];
          myCatalogViewdata?.columnDetails.splice(dragIndex, 1);
          myCatalogViewdata?.columnDetails.splice(dropIndex, 0, dragData);
          // });
    
          // If needed, you can dispatch your updated columns here:
    
          setTimeout(() => {
            const payloadData = {
              auctionDetailId: auctionDetailId,
              userLoginId: userId,
              catalogColumnConfigurationDetails: updatedColumns, // Use the updated columns with correct sortOrder
            };
    
            // Dispatch the API request to update the catalog column config
            dispatch(actionUrl.CatalogColumnConfigAction(payloadData));
          }, 1000);
        }
    };
    const tableRef = useRef(null);
     useEffect(() => {
        const handleKeyDown = (event) => {
          if (event.key !== "ArrowRight" && event.key !== "ArrowLeft") return;
    
          event.preventDefault(); // Prevent page scrolling
    
          // Select all enabled inputs & buttons
          const focusableElements = Array.from(
            tableRef.current.querySelectorAll("input:not([disabled]), button:not([disabled])")
          );
          const currentIndex = focusableElements.indexOf(document.activeElement);
    
          if (event.key === "ArrowRight") {
            // Move forward (like Tab), skipping disabled elements
            let nextIndex = currentIndex + 1;
            while (nextIndex < focusableElements.length && focusableElements[nextIndex].disabled) {
              nextIndex++;
            }
            if (nextIndex < focusableElements.length) {
              focusableElements[nextIndex].focus();
            }
          } else if (event.key === "ArrowLeft") {
            // Move backward (like Shift + Tab), skipping disabled elements
            let prevIndex = currentIndex - 1;
            while (prevIndex >= 0 && focusableElements[prevIndex].disabled) {
              prevIndex--;
            }
            if (prevIndex >= 0) {
              focusableElements[prevIndex].focus();
            }
          }
        };
    
        document.addEventListener("keydown", handleKeyDown);
        return () => document.removeEventListener("keydown", handleKeyDown);
      }, []);

    const onBlurRPTextField = (auctionItemDetailId, value, index) => {
      
        let newRp = value - previousValue
    
        const payload = {
          auctionDetailId: auctionDetailId,
          auctionItemDetailIds: [
            {
              auctionItemDetailId: auctionItemDetailId,
              newRP: newRp,
            },
          ],
          isManualCheck: 1
        };

        let nextRowIndex = index + 1;

        let newRowId = myCatalogViewdata?.liveBidDetails?.[nextRowIndex]?.auctionItemDetailId

        let newRpvalue = myCatalogViewdata?.liveBidDetails?.[nextRowIndex]?.columnDetails.find((data) => data.columnTypeId === 13).columnValue

        if (newRp != 0) {
          dispatch(actionUrl.ChangeReservePriceAction(payload));
        //   setshowListMsg(true);
          setRpValue(rpvalue)
        }

        setTimeout(() => {
          setPreviousValue(newRpvalue)
          setEditableRowId(newRowId);
        }, 1000);

        setTimeout(() => {
          setDisableField(false)
        }, 800)
      };
    

    useEffect(() => {
        if (alertMessage?.length == 1 ) {
          if (alertMessage?.[0]?.newReservePrice) {
            // Update the columnValue with new Reserve Price if it exists
            setMyCatalogViewData((prevData) => {
              const updatedData = prevData?.liveBidDetails.map((item) => {
                if (item.auctionItemDetailId === alertMessage?.[0]?.auctionItemDetailId) {
                  const updatedColumnDetails = item?.columnDetails.map((columnDetail) => {
                    if (columnDetail.columnTypeId === 13) {
                      // Update column value (RP) with the new value from alertMessage
                      columnDetail.columnValue = alertMessage?.[0]?.newReservePrice;
                    }
                    return columnDetail;
                  });
      
                  item.columnDetails = updatedColumnDetails;
                }
                return item;
              });
              return {...prevData, liveBidDetails: updatedData};
            });
    
            setuserWiseViewEnglishAuctionData((prevData) => {
              const updatedData = prevData?.liveBidDetails.map((item) => {
                if (item.auctionItemDetailId === alertMessage?.[0]?.auctionItemDetailId) {
                  const updatedColumnDetails = item?.columnDetails.map((columnDetail) => {
                    if (columnDetail.columnTypeId === 13) {
                      columnDetail.columnValue = alertMessage?.[0]?.newReservePrice;
                    }
                    return columnDetail;
                  });
      
                  item.columnDetails = updatedColumnDetails;
                }
                return item;
              });
              return {...prevData, liveBidDetails: updatedData};
            })
          } else {
            if(!isRpButtonClicked && !!previousValue) {
                setMyCatalogViewData((prevData) => {
                    const updatedData = prevData?.liveBidDetails.map((item) => {
                      if (item.auctionItemDetailId === alertMessage?.[0]?.auctionItemDetailId) {
                        const updatedColumnDetails = item?.columnDetails.map((columnDetail) => {
                          if (columnDetail.columnTypeId === 13) {
                            columnDetail.columnValue = previousValue;
                          }
                          return columnDetail;
                        });
            
                        item.columnDetails = updatedColumnDetails;
                      }
                      return item;
                    });
                    return {...prevData, liveBidDetails: updatedData};
                  });
            }
           
          }
        }
      }, [alertMessage]); 

      useEffect(() => {
        const currentAlert = alertMessage?.[0];
        const currentReservePrice = currentAlert?.newReservePrice;
        const targetItemId = currentAlert?.auctionItemDetailId;
        // Only proceed if there's a new RP, button is clicked, and value has changed
        if (
          currentReservePrice !== undefined &&
          isRpButtonClicked &&
          currentReservePrice !== lastAlertMessage?.current?.newReservePrice
        ) {
      
          setAuctionItemDetails((prevDetails) => ({
            ...prevDetails,
            [targetItemId]: [0],
          }));
      
          setMyCatalogViewData((prevData) => {
            const updatedData = prevData?.liveBidDetails.map((item) => {
              if (item.auctionItemDetailId === targetItemId) {
                const updatedColumnDetails = item?.columnDetails.map((columnDetail) => {
                  if (columnDetail.columnTypeId === 48) {
                    columnDetail.columnValue = 0;
                  }
                  return columnDetail;
                });
      
                item.columnDetails = updatedColumnDetails;
              }
              return item;
            });
      
            return { ...prevData, liveBidDetails: updatedData };
          });
        }
      
        // You can keep the rest of the `else if` unchanged
        else if (alertMessage?.length > 0) {
          setMyCatalogViewData((prevData) => {
            const updatedData = prevData?.liveBidDetails.map((item) => {
              alertMessage?.forEach((alert) => {
                if (item.auctionItemDetailId === alert?.auctionItemDetailId) {
                  const hbpValue = item?.columnDetails.filter((column) => column.columnTypeId === 11).map((column) => column.columnValue)[0];
                  const parsedHbpValue = hbpValue == '' ? 0 : parseFloat(hbpValue) || 0;
      
                  const updatedColumnDetails = item?.columnDetails.map((columnDetail) => {
                    if (columnDetail.columnTypeId === 48) {
                      if (alert?.newReservePrice && !isNaN(alert?.newReservePrice)) {
                        columnDetail.columnValue = parsedHbpValue - alert?.newReservePrice;
                      }
                    }
                    return columnDetail;
                  });
      
                  item.columnDetails = updatedColumnDetails;
                }
              });
              return item;
            });
      
            return { ...prevData, liveBidDetails: updatedData };
          });
        }
      }, [alertMessage, isRpButtonClicked]);
      

      useEffect(() => {
        if (myCatalogViewdata?.liveBidDetails?.length > 0) {
          myCatalogViewdata?.liveBidDetails.forEach((item) => {
            const alert = alertMessage?.find(
              (alertItem) => alertItem?.auctionItemDetailId === item?.auctionItemDetailId
            );
            
            if (alert) {
              const rpValue = item?.columnDetails?.filter(
                (column) => column?.columnTypeId === 48
              )?.map((column) => column?.columnValue)[0];
      
              // Update auctionItemDetails with the new reserve price (newRpValue)
              setAuctionItemDetails((prevDetails) => ({
                ...prevDetails,
                [alert?.auctionItemDetailId]: [rpValue],
              }));
            }
          });
        }
        if (alertMessage?.length > 0) {
          lastAlertMessage.current = alertMessage[0]; 
        }
      }, [myCatalogViewdata?.liveBidDetails, alertMessage]); 
      

    let statusSoldUnsold = "";  
    return (
        <table aria-labelledby="tableTitle2" id="example"  ref={tableRef}  class="stripe- row-border order-column table ">
            <thead>
                <tr>
                    {myCatalogViewdata?.columnDetails.map(
                        (column, index) =>
                            column.isShown == 1 ? (
                                <th
                                    key={index}
                                    draggable
                                    onDragStart={(e) => handleDragStart(e, index)}
                                    style={{minWidth: column.columnTypeId=== 13 ? '75px' : 'auto'}}
                                    onDragOver={handleDragOver}
                                    onDrop={(e) => handleDrop(e, index)}
                                >
                                    {column.columnName}
                                </th>
                            ) : (
                                ""
                            )
                    )}
                </tr>
            </thead>
            <tbody>
                {myCatalogViewdata?.liveBidDetails &&
                    myCatalogViewdata?.liveBidDetails.map((row, index) => (
                        <tr key={index}>
                            {row?.columnDetails.map((item, i) =>
                                myCatalogViewdata?.columnDetails[i].isShown ==
                                    1 ? (
                                    <td
                                        className={
                                            selectedRowsRemove.includes(
                                                row.auctionItemDetailId
                                            )
                                                ? "selectedRowColor1"
                                                : item.columnColor
                                        }
                                        key={i}
                                    >
                                        {item.columnTypeId === 15 ? (
                                            <p
                                                onClick={() =>
                                                    handleSelectRowRemove(
                                                        row.auctionItemDetailId,
                                                        row?.columnDetails
                                                    )
                                                }
                                            >
                                                {(statusSoldUnsold = item.columnValue)}
                                            </p>
                                        ) : item.columnTypeId === 13 &&
                                            editableRowId ===
                                            row.auctionItemDetailId ? (
                                            <input
                                                type="number"
                                                id={row.auctionItemDetailId}
                                                disabled={disableField}
                                                onChange={(event) => {
                                                  const value = event.target.value;
                        
                                                  if (value.length <= 18) {
                                                    setCurrentValue(value);
                                                    handleChangeCatalog(
                                                      item,
                                                      row.auctionItemDetailId,
                                                      item.columnTypeId,
                                                      value,
                                                      "columnValue"
                                                    );
                                                  }
                                                }}
                                                // onClick={() => handleSelectRow(row.auctionItemDetailId)}sss
                                                onBlur={() => {
                                                    handleBlur(
                                                      row.auctionItemDetailId
                                                    )
                                                    setEditableRowId(null)
                                                    setPreviousValue(null)
                                                }}
                                                onKeyDown={(e) => {
                                                  if (e.key === "Enter") {
                                                    e.preventDefault(); // Prevent the default action (blur)
                                                    setDisableField(true);
                                                    onBlurRPTextField(
                                                      row.auctionItemDetailId,
                                                      item.columnValue,
                                                      index
                                                    );
                                                  } else {
                                                    setIsKeyboardEvent(true); // Mark that a keyboard event occurred
                                                  }
                                                }}
                                                onClick={(e) =>
                                                    handleDoubleClick(
                                                        row.auctionItemDetailId,
                                                        item.columnValue
                                                    )
                                                }
                                                onFocus={() => {
                                                  setCurrentValue(''); 
                                                }}
                                                autoFocus
                                                value={currentValue}
                                                readOnly={
                                                    editableRowId !==
                                                    row.auctionItemDetailId
                                                }
                                            />
                                        ) : item.columnTypeId === 13 &&
                                            editableRowId !==
                                            row.auctionItemDetailId ? (
                                            <p
                                                id={row.auctionItemDetailId}
                                                onChange={(event) =>
                                                    handleChangeCatalog(
                                                        item,
                                                        row.auctionItemDetailId,
                                                        item.columnTypeId,
                                                        event.target.value,
                                                        "columnValue"
                                                    )
                                                }
                                                // onClick={() => handleSelectRow(row.auctionItemDetailId)}
                                                onClick={(e) =>
                                                    handleDoubleClick(
                                                        row.auctionItemDetailId,
                                                        item.columnValue
                                                    )
                                                }
                                            >
                                                {item.columnValue}
                                            </p>
                                        ) : item.columnTypeId === 31 ? (
                                            <input
                                                type="number"
                                                id={row.auctionItemDetailId}
                                                onChange={(event) =>
                                                    handleChangeCatalog(
                                                        item,
                                                        row.auctionItemDetailId,
                                                        item.columnTypeId,
                                                        event.target.value,
                                                        "columnValue"
                                                    )
                                                }
                                                onFocus={(event) => {
                                                    if (event.target.value === "0") {
                                                      event.target.value = "";
                                                    }
                                                  }}
                                                  onBlur={(event) => {
                                                    if (event.target.value === "") {
                                                      event.target.value = "0";
                                                    }
                                                  }}
                                                value={item.columnValue}
                                                disabled
                                            />
                                        ) : item.columnTypeId === 33 ? (
                                            <input
                                                type="number"
                                                id={row.auctionItemDetailId}
                                                onChange={(event) =>
                                                    handleChangeCatalog(
                                                        item,
                                                        row.auctionItemDetailId,
                                                        item.columnTypeId,
                                                        event.target.value,
                                                        "columnValue"
                                                    )
                                                }
                                                onFocus={(event) => {
                                                    if (event.target.value === "0") {
                                                      event.target.value = "";
                                                    }
                                                  }}
                                                  onBlur={(event) => {
                                                    if (event.target.value === "") {
                                                      event.target.value = "0";
                                                    }
                                                  }}
                                                value={item.columnValue}
                                                disabled
                                            />
                                        ) : item.columnTypeId === 32 ? (
                                            <input
                                                type="number"
                                                id={row.auctionItemDetailId}
                                                onChange={(event) =>
                                                    handleChangeCatalog(
                                                        item,
                                                        row.auctionItemDetailId,
                                                        item.columnTypeId,
                                                        event.target.value,
                                                        "columnValue"
                                                    )
                                                }
                                                onFocus={(event) => {
                                                    if (event.target.value === "0") {
                                                      event.target.value = "";
                                                    }
                                                }}
                                                onBlur={(event) => {
                                                    if (event.target.value === "") {
                                                      event.target.value = "0";
                                                    }
                                                }}
                                                value={item.columnValue}
                                                disabled={
                                                    userWiseViewEnglishAuctionData?.userStatus ==
                                                        2
                                                        ? true
                                                        : row.isBQEnable == 0
                                                            ? true
                                                            : userWiseViewEnglishAuctionData?.cstatus ==
                                                                6
                                                                ? true
                                                                : false
                                                }
                                            />
                                        ) : item.columnTypeId === 34 ||
                                            item.columnTypeId === 35 ||
                                            item.columnTypeId === 36 ? (
                                            <input
                                                type="number"
                                                disabled={
                                                    userWiseViewEnglishAuctionData?.userStatus ==
                                                        2
                                                        ? true
                                                        : userWiseViewEnglishAuctionData?.cstatus ==
                                                            6
                                                            ? true
                                                            : false
                                                }
                                                id={row.auctionItemDetailId}
                                                onChange={(event) =>
                                                    handleChangeCatalog(
                                                        item,
                                                        row.auctionItemDetailId,
                                                        item.columnTypeId,
                                                        event.target.value,
                                                        "columnValue"
                                                    )
                                                }
                                                onFocus={(event) => {
                                                    if (event.target.value === "0") {
                                                      event.target.value = "";
                                                    }
                                                }}
                                                onBlur={(event) => {
                                                    if (event.target.value === "") {
                                                      event.target.value = "0";
                                                    }
                                                }}
                                                value={item.columnValue}
                                            />
                                        ) : item.columnTypeId === 37 ? (
                                            <div className="BtnGroup d-flex justify-space-even">
                                                <button
                                                    disabled={
                                                        userWiseViewEnglishAuctionData?.userStatus ==
                                                            2
                                                            ? true
                                                            : item.columnStatus == "Sold" ||
                                                                item.columnStatus == "Un sold"
                                                                ? true
                                                                : statusSoldUnsold == "Sold" ||
                                                                    statusSoldUnsold == "Un sold"
                                                                    ? true
                                                                    : userWiseViewEnglishAuctionData?.cstatus ==
                                                                        6
                                                                        ? true
                                                                        : false
                                                    }
                                                    onClick={() =>
                                                        handleButtonCatalog("0", item, row)
                                                    }
                                                >
                                                    {item.columnValue}
                                                </button>
                                            </div>
                                        ) : item.columnTypeId === 38 ? (
                                            <div className="BtnGroup d-flex justify-space-even">
                                                <button
                                                    disabled={
                                                        userWiseViewEnglishAuctionData?.userStatus ==
                                                            2
                                                            ? true
                                                            : item.columnStatus == "Sold" ||
                                                                item.columnStatus == "Un sold"
                                                                ? true
                                                                : statusSoldUnsold == "Sold" ||
                                                                    statusSoldUnsold == "Un sold"
                                                                    ? true
                                                                    : row.isEnable == 0
                                                                        ? true
                                                                        : userWiseViewEnglishAuctionData?.cstatus ==
                                                                            6
                                                                            ? true
                                                                            : false
                                                    }
                                                    onClick={() =>
                                                        handleButtonCatalog("1", item, row)
                                                    }
                                                >
                                                    {item.columnValue}
                                                </button>
                                            </div>
                                        ) : item.columnTypeId == 45 ? (
                                            <button
                                                disabled={
                                                    userWiseViewEnglishAuctionData?.userStatus ==
                                                        2
                                                        ? true
                                                        : false || isRpButtonClicked && auctionItemRowId == row.auctionItemDetailId
                                                }
                                                onClick={() =>
                                                    handleButtonChangePrice(
                                                        row.auctionItemDetailId,
                                                        row?.columnDetails
                                                    )
                                                }
                                            >
                                                {item.columnValue}
                                            </button>
                                        ) : item.columnTypeId == 10 ||
                                            item.columnTypeId == 11 ? (
                                            item.columnValue == 0 ? (
                                                ""
                                            ) : (
                                                <p
                                                    onClick={() =>
                                                        handleSelectRowRemove(
                                                            row.auctionItemDetailId,
                                                            row?.columnDetails
                                                        )
                                                    }
                                                >
                                                    {item.columnValue}
                                                </p>
                                            )
                                        ) : item.columnTypeId == 50 ? (
                                            item.columnValue == 0 ? (
                                                ""
                                            ) : (
                                                <p
                                                    onClick={() =>
                                                        handleSelectRowRemove(
                                                            row.auctionItemDetailId,
                                                            row?.columnDetails
                                                        )
                                                    }
                                                >
                                                    {item.columnValue}
                                                </p>
                                            )
                                        ) : item.columnTypeId === 13 ? (
                                            <p
                                                onClick={() =>
                                                    handleSelectRowRemove(
                                                        row.auctionItemDetailId,
                                                        row?.columnDetails
                                                    )
                                                }
                                            >
                                                {row.isShowRP == 1
                                                    ? item.columnValue
                                                    : " "}
                                            </p>
                                        ) : (
                                            <p
                                                onClick={() =>
                                                    handleSelectRowRemove(
                                                        row.auctionItemDetailId,
                                                        row?.columnDetails
                                                    )
                                                }
                                            >
                                                {item.columnValue}
                                            </p>
                                        )}
                                    </td>
                                ) : null
                            )}
                        </tr>
                    ))}
            </tbody>
        </table>
    )
}
export default CatalogTable;